import { Role } from '@/core/components/auth/auth.types'
import { ErrorComponent } from '@/core/components/ErrorComponent'
import { LoadingList } from '@/core/components/LoadingList'
import { propertyByIdQueryOptions } from '@/core/components/sites/propertyQueryOptions'
import { ratesQueryOptions } from '@/core/components/sites/site/rates-and-packages/rates/ratesQueryOptions'
import { redirect } from '@tanstack/react-router'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

const ratesSearchSchema = z.object({
  search: z.string().catch(''),
  page: z.number().catch(1),
  pageSize: z.number().catch(10),
  sortBy: z
    .enum([
      'id',
      'status',
      'code',
      'rateCode',
      'externalCode',
      'rateCategory',
      'title',
      'type',
      'startSell',
      'endSell',
      'minLeadTime',
      'LOSmin',
      'orderIndex',
    ])
    .catch('code'),
  orderBy: z.enum(['asc', 'desc']).catch('desc'),
  tab: z.enum(['rates', 'rateGroups']).catch('rates'),
})

export const Route = createFileRoute(
  '/_layout/dashboard/sites/$siteId/rates-and-packages/rates/'
)({
  validateSearch: (search) => ratesSearchSchema.parse(search),
  beforeLoad: ({ context: { auth } }) => {
    if (auth.isExpired()) {
      return
    }
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/',
      })
    }
    if (auth.user?.role === Role['Front-Desk']) {
      throw redirect({
        to: '/dashboard',
      })
    }
  },
  loader: ({ context: { queryClient, auth }, params: { siteId } }) => {
    const rates = queryClient.ensureQueryData(
      ratesQueryOptions(siteId, auth.token!)
    )
    const property = queryClient.ensureQueryData(
      propertyByIdQueryOptions(siteId, auth.token!)
    )

    return {
      rates,
      property,
    }
  },
  errorComponent: ErrorComponent,
  pendingComponent: LoadingList,
})
